const IMAGEKIT_URL = (process.env.REACT_APP_IMAGEKIT_URL || 'https://ik.imagekit.io/thehumanitytrust')
  .trim()
  .replace(/\/+$/, '');

const IMAGEKIT_MEDIA_FOLDER = '/events/images';

export const mediaUrl = (path: string): string => {
  if (/^https?:\/\//i.test(path)) {
    return path;
  }

  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  const filename = normalizedPath.split('/').pop() || '';
  return `${IMAGEKIT_URL}${IMAGEKIT_MEDIA_FOLDER}/${encodeURI(filename)}`;
};

